import styled from 'styled-components/macro';
import {
  headingTypeMap,
  fontFamilyMap,
  sizesMap,
  textLineHeight,
  headingLineHeight,
} from '../../typography/utils';

export default styled.div<{ color?: string; linkColor?: string }>`
  * {
    font-family: ${(p) => p.theme.fonts[fontFamilyMap.sans]};
    color: ${(p) => p.color ?? p.theme.colors.black};
  }

  a {
    color: ${(p) => p.linkColor ?? p.theme.colors.primary20b};
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: ${(p) => p.theme.fonts[fontFamilyMap.sans]};
    font-weight: 400;
    letter-spacing: 0.02em;
    padding: 0;
    margin: 0 0 0.4em 0;
  }

  h1 {
    font-size: ${(p) => headingTypeMap['1'].size};
    line-height: ${(p) => headingLineHeight};
  }

  h2 {
    font-size: ${(p) => headingTypeMap['2'].size};
    line-height: ${(p) => headingLineHeight};
  }

  h3 {
    font-size: ${(p) => headingTypeMap['3'].size};
    line-height: ${(p) => headingLineHeight};
  }

  h4 {
    font-size: ${(p) => headingTypeMap['4'].size};
    line-height: ${(p) => headingLineHeight};
  }

  h5 {
    font-size: ${(p) => headingTypeMap['5'].size};
    line-height: ${(p) => headingLineHeight};
  }

  h6 {
    font-size: ${(p) => headingTypeMap['6'].size};
    line-height: ${(p) => headingLineHeight};
  }

  p {
    font-family: ${(p) => p.theme.fonts[fontFamilyMap.serif]};
    font-weight: 400;
    letter-spacing: 0.004em;
    padding: 0;
    margin: 0 0 0.4em 0;
    font-size: ${sizesMap.base.size};
    line-height: ${textLineHeight};
  }
`;
